import { is } from 'stdlib/is'

/** Támogatott a Gamepad API? */
export default function isGamePadSupported (): boolean {
  // oxlint-disable-next-line no-restricted-globals -- navigator
  if (is.property(navigator, 'getGamepads')) {
    return true
  }

  if (is.property(window, 'onconnectedgamepad')) {
    return true
  }

  return false
}
